export default __webpack_public_path__ + "images/210684df0bfb73ba30b3705c70288377-motorcycle.webp";